(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsViewDashboardsAs', ['$http', '$location', '$rootScope', '$route', 'Api', 'Dashboards', 'User', 'ViewDashboardsAs', 'wsEventNames', function ($http, $location, $rootScope, $route, Api, Dashboards, User, ViewDashboardsAs, wsEventNames) {
    return {
      templateUrl: "modules/common/directives/view-dashboards-as/view-dashboards-as.html",
      link: function link($scope) {
        var impersonationUrl = Api.url("/view-dashboards-as", true),
          initialLoad = true;
        $scope.viewDashboardsAs = ViewDashboardsAs;
        $scope.showViewDashboardsAs = false;
        function setShowViewDashboardsAs(value) {
          $scope.showViewDashboardsAs = value;
        }
        function setViewDashboardsAsActive(value, selectedUser) {
          ViewDashboardsAs.isActive = value;
          ViewDashboardsAs.selectedUser = selectedUser;
          $scope.selectedUser = selectedUser;
          $rootScope.$broadcast(wsEventNames.viewDashboardsAs.active, value, selectedUser);
          if (!initialLoad) {
            Dashboards.update();
          }
          initialLoad = false;
        }
        function handleError(reason) {
          $scope.error = reason.data.message;
        }
        $scope.$on(wsEventNames.viewDashboardsAs.show, function (evt, value) {
          setShowViewDashboardsAs(value);
        });
        $http.get(impersonationUrl).then(function (user) {
          setShowViewDashboardsAs(true);
          setViewDashboardsAsActive(true, user.data);
        }, function () {
          setShowViewDashboardsAs(false);
          setViewDashboardsAsActive(false, null);
        });
        $scope.beginViewDashboardsAs = function () {
          var currentUser = User.get();
          $http.post(impersonationUrl, {
            userName: $scope.selectedUser.username,
            organizationId: currentUser.organization.id
          }).then(function () {
            setViewDashboardsAsActive(true, $scope.selectedUser);
            if ($location.path() === "/dashboard/default") {
              $route.reload();
            } else {
              $location.path("/dashboard/default");
            }
          }, handleError);
        };
        $scope.endViewDashboardsAs = function () {
          $http.delete(impersonationUrl).then(function () {
            setViewDashboardsAsActive(false, null);
            $route.reload();
          }, handleError);
        };
        $scope.typeahead = function (query) {
          return $http.get(Api.url("/filtered-memberships", false), {
            params: {
              "in_user.name": query,
              "order_by": "user.name",
              "_limit": 4
            }
          }).then(function (response) {
            return _.map(response.data.results, function (membership) {
              return membership.user;
            });
          });
        };
      }
    };
  }]);
})();
